import React, { useEffect, useState } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { RadioInput } from '../../../Helpers/Inputs';
import { object, string } from 'yup';
import { Button, makeStyles } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem } from '../../../../sessionStorage';
import { useHistory } from 'react-router-dom';
import HandleNavigateToLicensingAndAppointmentLink from '../../../Helpers/HandleNavigateToLicensingAndAppointmentLink';

const useStyles = makeStyles(theme => ({
    link: {
      color: `${theme.palette.primary.main} !important`,
      cursor: 'pointer'
    },
  }))

export default function CaseInitiation(props) {
    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: CaseInitiation.ValidationSchema,
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });
    const history = useHistory();
    const classes = useStyles();

    const [validateMessage, setValidateMessage] = useState('');
    const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
    const insuranceSpecialistURL = advisorObj && advisorObj.insuranceSpecialistURL;

    const generateUniqueID = () => {
        const uniqueID = uuid();
        window.location = `${insuranceSpecialistURL}?ApplicationID=${uniqueID}`;
    }

    const handleValueChange = (field, value) => {
        setValidateMessage('');
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };

    useEffect(() => {
        register({ name: 'caseInitiateType' });
        setValue('caseInitiateType', props.formState.caseInitiateType);

    }, [register])

    const onQuoteClick = (caseInitiateType) => {
        if (caseInitiateType === "") {
            setValidateMessage('This field is required.');
        }
        if (caseInitiateType !== "") {
            setValidateMessage('');
            if (caseInitiateType !== "" && caseInitiateType === "VirtualInsurance") {
                props.onNext();
            } else {
                generateUniqueID();
            }
        }
    }


    return (
        <Container fluid className='quote-class border-class'>
            <form className="quoteDeatilForm" onSubmit={handleSubmit(onQuoteClick)}>
                <Row className="justify-content-center pt-4">
                    <Col lg={8}>
                        <div class="sectionHeader">Please select one and Continue:  </div>
                        <div className="col-sm-12">
                            <Form.Group className='mb-0'>
                                <RadioInput
                                    name="caseInitiateType"
                                    id="caseInitiateType"
                                    label=""
                                    value={props.formState.caseInitiateType}
                                    radios={[{ value: "VirtualInsurance", label: "Initiate the Case Design with a Digital Insurance Planning Specialist" }]}
                                    onChange={e => handleValueChange('caseInitiateType', e.target.value)}
                                    inputRef={register}
                                    className="radio-grp"
                                />
                            </Form.Group>
                            <div className='case-text mb-4'>
                                Begin the insurance planning process by completing an initial fact-finding questionnaire through the platform. A dedicated team member from Covr Technologies will then work with you to identify solutions consistent with your client’s profile. Case design and implementation will be managed by our Insurance Support Team and the Digital Platform.
                            </div>
                        </div>

                        <div className="col-sm-12">
                            <Form.Group className='mb-0'>
                                <RadioInput
                                    name="caseInitiateType"
                                    id="caseInitiateType"
                                    label=""
                                    value={props.formState.caseInitiateType}
                                    radios={[{ value: "LocalInsurance", label: "Initiate Case Design with Your Local Insurance Planning Specialist" }]}
                                    onChange={e => handleValueChange('caseInitiateType', e.target.value)}
                                    inputRef={register}
                                    className="radio-grp"
                                />
                            </Form.Group>
                            <div className='case-text'>
                                Begin the insurance planning process by contacting one of your local Insurance Planning Specialists (IPS) from BKA Financial, Capitas Financial, or TIME Financial. The IPS will be available to work with you and your client in-person to identify solutions consistent with your client’s profile. Case design and implementation will be managed by your local IPS.
                            </div>
                            <div className='validation-message'>{validateMessage}</div>
                            <br /><br />
                            <div className='case-text'>For any questions regarding Morgan Stanley’s Licensing Policy, click <a target="_blank" className={classes.link} href="http://mssbintranet.msdwis.com/uiplsds/app-bin/intranetsolution/Operations/General/Insurance/INS_Licensing.page?">HERE</a>.<br />
                                To view your current Licenses and Appointments on the Insurance Licensing Tool (ILT) click <a onClick={() => HandleNavigateToLicensingAndAppointmentLink()} className={classes.link}>HERE</a>.<br /><br />
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className='text-center mb-3'>
                    <Button variant="contained" size="medium" color="primary" type="submit" onClick={() => onQuoteClick(props.formState.caseInitiateType)}>
                        Continue
                    </Button>
                </div>
            </form>
        </Container>
    );
}

CaseInitiation.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

CaseInitiation.ValidationSchema = object().shape({
    caseInitiateType: string().required("This field is required."),
});

CaseInitiation.DefaultFormState = () => {
    return {
        caseInitiateType: '',
    };
};



// WEBPACK FOOTER //
// ./src/components/Product/PermLifeInsurance/steps/CaseInitiation.js